<section class="pupil-component">
  <div class="pupil-component__card">
    <div class="pupil-component__card__header" *ngIf="isTeach">
      <span class="pupil-component__card__header__bank" (click)="goToStudentAccount()">счет</span>
      <span (click)="close()">
        <app-svg-icon
          class="close-icon"
          [src]="closeIcon">
        </app-svg-icon>
      </span>
    </div>
    <div class="pupil-component__card__body">
      <div class="student-photo" *ngIf="pupil.photo_url">
        <div class="student-photo__wrapper"
             [ngClass]="pupil.gender === GENDER.FEMALE ? 'female': 'male'">
          <img class="image" src="{{ MAIN_DOMAIN }}{{ pupil.photo_url }}" alt=""/>
        </div>
      </div>
      <div class="pupil-fullname">
        {{pupil.surname}} {{pupil.name}}
      </div>
    </div>
    <div class="pupil-component__card__footer">
      <div class="pupil-component__card__footer__extra-exercises">
        <div class="student-ee-stat" *ngIf="exExerciseStat?.correct > 0 || exExerciseStat?.incorrect > 0">
          <span class="student-ee-stat__item student-ee-stat__item_header">Доп. з.:</span>
          <span class="student-ee-stat__item">
            <span class="correct">{{ exExerciseStat?.correct }}</span> /
            <span class="incorrect">{{ exExerciseStat?.incorrect }}</span>
          </span>
        </div>
      </div>

      <div class="pupil-component__card__footer__exercises">
        <ul class="student-stat" *ngIf="lessonResults.length > 0">
          <li class="student-stat__item student-stat__item_header">
            <div class="header">Box</div>
            <div class="header">Решено</div>
          </li>
          <li
            class="student-stat__item student-stat__item_info"
            *ngFor="let result of lessonResults">
            <div class="box-title">{{result.box_number}}</div>
            <div class="results">
              <span class="all-correct" *ngIf="result.incorrect === 0">{{result.correct}}</span>
              <span class="all-incorrect" *ngIf="result.correct === 0">{{result.incorrect}}</span>
              <span class="result" *ngIf="result.correct !== 0 && result.incorrect !== 0">
              {{result.correct}} / <span class="incorrect">{{result.incorrect}}</span></span>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</section>
